import { useContext } from "react";

import { ExtensionsContext } from "../contexts/bots/ExtensionsContext";

const useExtensions = () => useContext(ExtensionsContext);

export default useExtensions;
